import "./App.css";
import Navbar from "./pages/Navbar";
import { useLocation } from "react-router-dom";
import Hero from "./pages/Hero";
import Skill from "./pages/Skill";
import Projects from "./pages/Project";
import React, { useState } from "react";
import Articles from "./pages/Articles";
import Journey from "./pages/Journey";
import { Helmet } from "react-helmet";

const SITE_URL = "https://www.yusuf-fachroni.my.id/";
const SITE_TITLE = "Yusuf Fachroni | Flutter & Mobile Developer";
const SITE_DESCRIPTION =
  "Portfolio of Yusuf Fachroni — Flutter & mobile developer with 10+ years of experience building apps (100k+ downloads), React web, and Spring Boot backends.";

function App() {
  const location = useLocation();
  const heroRef = useState(React.createRef());
  const skillRef = useState(React.createRef());
  const projectRef = useState(React.createRef());
  const articleRef = useState(React.createRef());
  return (
    <>
      <Helmet>
        <html lang="en" />
        <title>{SITE_TITLE}</title>
        <meta name="description" content={SITE_DESCRIPTION} />
        <meta name="robots" content="index, follow, max-image-preview:large" />
        <link rel="canonical" href={SITE_URL} />
        <meta property="og:title" content={SITE_TITLE} />
        <meta property="og:description" content={SITE_DESCRIPTION} />
        <meta property="og:url" content={SITE_URL} />
        <meta
          property="og:image"
          content="https://www.yusuf-fachroni.my.id/assets/icon/icon.png"
        />
        <meta name="twitter:title" content={SITE_TITLE} />
        <meta name="twitter:description" content={SITE_DESCRIPTION} />
        <link
          rel="shortcut icon"
          type="image/png"
          href="/assets/icon/icon.png"
        />
      </Helmet>
      <Navbar
        routePath={location.pathname}
        heroRef={heroRef}
        skillRef={skillRef}
        projectRef={projectRef}
      />
      <main>
        <Hero refs={heroRef} />
        <Skill refs={skillRef} />
        <Journey refs={projectRef} />
        <Articles refs={articleRef} />
        <Projects refs={projectRef} />
      </main>
    </>
  );
}

export default App;
